import { ForbidCircleIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { useHasPermission } from '@vlabs/permissions';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useBlockUserTranslation } from '../i18n';
import type { BlockUserProps } from '../types';
import { useBlockUser } from './useBlockUser';

type BlockUserButtonProps = BlockUserProps & Omit<ButtonProps, 'onClick'>;

const displayName = 'BlockUserButton';
const testid = buildTestid(displayName);

function BlockUserButton({
  userId,
  'data-testid': dataTestId = undefined,
  ...props
}: BlockUserButtonProps): JSX.Element | null {
  const hasAccess = useHasPermission('users', 'update');
  if (!hasAccess) return null;

  const { t } = useBlockUserTranslation();
  const blockUser = useBlockUser({ userId });
  return (
    <Button
      icon={<ForbidCircleIcon />}
      kind="negative"
      onClick={blockUser}
      {...testid(dataTestId)}
      {...props}
    >
      {t('button')}
    </Button>
  );
}

BlockUserButton.displayName = displayName;

export { BlockUserButton };
